<div class="flex justify-center items-center gap-4">
  <div class="flex flex-col gap-1 items-center">
    <mat-icon
      class="text-blue-500 text-2xl cursor-pointer"
      (click)="updateValue('h', 1)"
      >expand_less</mat-icon
    >
    <input
      [readonly]="readonly"
      type="number"
      [(ngModel)]="timeJSON.h"
      class="text-center p-4 text-lg outline-none font-bold border-blue-500 rounded-md border w-52 px-5"
      (blur)="handleBlur('h', 0, 23)"
    />
    <mat-icon
      class="text-blue-500 text-2xl cursor-pointer"
      (click)="updateValue('h', -1)"
      >expand_more</mat-icon
    >
  </div>
  <span *ngIf="format == 'h:m:s' || format == 'h:m'">:</span>

  <div
    class="flex flex-col items-center"
    *ngIf="format == 'h:m:s' || format == 'h:m'"
  >
    <mat-icon
      class="text-blue-500 text-2xl cursor-pointer"
      (click)="updateValue('m', 1)"
      >expand_less</mat-icon
    >
    <input
    [readonly]="readonly"
      type="number"
      [(ngModel)]="timeJSON.m"
      class="text-center p-4 text-lg outline-none font-bold border-blue-500 rounded-md border w-52 px-5"
      (blur)="handleBlur('m', 0, 59)"
    />
    <mat-icon
      class="text-blue-500 text-2xl cursor-pointer"
      (click)="updateValue('m', -1)"
      >expand_more</mat-icon
    >
  </div>
  <span *ngIf="format == 'h:m:s'">:</span>
  <div class="flex flex-col gap-1 items-center" *ngIf="format == 'h:m:s'">
    <mat-icon
      class="text-blue-500 text-2xl cursor-pointer"
      (click)="updateValue('s', 1)"
      >expand_less</mat-icon
    >
    <input
    [readonly]="readonly"
      type="number"
      [(ngModel)]="timeJSON.s"
      class="text-center p-4 text-lg outline-none font-bold border-blue-500 rounded-md border w-52 px-5"
      (blur)="handleBlur('s', 0, 59)"
    />
    <mat-icon
      class="text-blue-500 text-2xl cursor-pointer"
      (click)="updateValue('h', -1)"
      >expand_more</mat-icon
    >
  </div>
</div>
